module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "kbx-counter",
    attrs: {
      "klickbox-edit-item": "counter",
      "klickbox-edit-label": _vm.$t('edit.canvas.progressbar')
    }
  }, [_c('span', {
    staticClass: "kbx-counter-label",
    style: (_vm.getLabelStyle())
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "kbx-counter-pie",
    attrs: {
      "klickbox-edit-item-dad": "counter",
      "klickbox-edit-item": "progress-bullet-done",
      "klickbox-edit-label": _vm.$t('edit.canvas.active_item'),
      "klickbox-edit-not-highlight": ""
    }
  }, [_c('div', {
    staticClass: "left-side half-circle",
    style: (_vm.getDoneStyle())
  }), _vm._v(" "), _c('div', {
    staticClass: "right-side half-circle",
    style: (_vm.getDoneStyle())
  })]), _vm._v(" "), _c('div', {
    staticClass: "kbx-counter-shadow",
    style: (_vm.getDefaultStyle()),
    attrs: {
      "klickbox-edit-item-dad": "counter",
      "klickbox-edit-item": "progress-bullet-default",
      "klickbox-edit-label": _vm.$t('edit.canvas.default_item'),
      "klickbox-edit-not-highlight": ""
    }
  })])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-624a8439!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/Counter.vue
 ** module id = 846
 ** module chunks = 1
 **/